export default __webpack_public_path__ + "static/media/as-4.8a1bc98e.png";